import { render, staticRenderFns } from "./MedicineIndicationsTable.vue?vue&type=template&id=03fb683e&scoped=true"
import script from "./MedicineIndicationsTable.vue?vue&type=script&lang=js"
export * from "./MedicineIndicationsTable.vue?vue&type=script&lang=js"
import style0 from "./MedicineIndicationsTable.vue?vue&type=style&index=0&id=03fb683e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03fb683e",
  null
  
)

export default component.exports